<template>
	<div class="showroom">
		<btn v-for="button in buttons" :key="button._id" :l="button.l" :i="button.i" :t="button.t" :s="button.s" iR="" />
		<inputi placeholder="123"  :value="input" @change="change"/>
		<inputi placeholder="123" label="Хаю хай" :value="input" @change="change"/>
		<textbox :value="input" label="Хаю хай"  @change="change"></textbox>
		<div v-html="input"></div>
		<btn l="Knopka" i="modal" t="p" s="m" iR="" @press="openModal"/>
	</div>
</template>
<script>

import {v4} from "uuid";
let getRandom = function(arr){
	return arr[Math.floor(Math.random()*arr.length)];
}
	export default {
		name:"showroom",
		props:[],
		methods:{
			change(value){
				this.input = value;
			},
			openModal(){
				this.$store.emit("openModal", "modal-id")
			}
		},
		data(){
			return {
				input:"value",
				buttons: [1,2,3,4,5,6,7,8,9,10,11,1,1,1,1,1].map(()=>{
					return {
						_id:v4(),
						l:getRandom(["Кнопка","Кнопко","Это же кнопка","Дааа"]),
						i:getRandom(["search","hotel","inbox","key"]),
						t:getRandom(["p","s","w","i","d"]),
						s:getRandom(["xs","s","m","l","xl"]),
						iR:""
					}
				})
			}
		}
	}
</script>
<style scoped>
	.showroom{
		font-size:24px;
		color:red;
	}
</style>